module.exports = __webpack_public_path__ + "img/cart-empty.ed6cd7e0.webp";